import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import axios from 'axios'
import { FileUploader } from "react-drag-drop-files";
export default function SingleUser() {
    const [details, setDetails] = useState(JSON.parse(localStorage.getItem(`user-${window.location.href.split('/').pop()}`)) || {
        first_name: '',
        email: '',
        id: '',
        last_name: '',
        project_selecteds:[],
        Get_detailes: {
            gender: '',
            address: '',
            country: '',
            date_of_birth: '',
            experiance: '',
            id: '',
            name: '',
            phone_number: '',
            profile_pic: '',
            resume: '',
            specififcation: '',
            state_region: '',

        }
    });
    // const Table=()=>{
    //     var rows = []
    //     for (const property in details)
    //     if(details[property]&&property!='Get_detailes')rows.push(<tr><td>{property} : </td><td>{details[property]}</td></tr>)
    //     for (const property in details.Get_detailes)
    //     if(details.Get_detailes[property] && property!='user' && property!='user')rows.push(<tr><td>{property} : </td><td>{details.Get_detailes[property]}</td></tr>)
    //     console.log(rows)
    //     return <>{rows}</>
    // }
    let type = localStorage.getItem('type')
    const getUser = async () => {
        var str = window.location.href;
        var res = str.split("/").pop();
        await axios.get(`${process.env.REACT_APP_API_URL1}/${type == 'PROJECT MANAGER' ? 'project' : 'hr'}/user_module/${res}/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                setDetails(response.data)
                setUr(false)
            }).catch(err => {
                console.log(err)
            })
    }
    useEffect(async () => {
        console.log(details.first_name)
        if (details.first_name!='')
            localStorage.removeItem(`user-${window.location.href.split('/').pop()}`)
        else {
            await getUser()
        }
    }, [])
    const putP = async () => {
        var form_data = new FormData();
        let ids = []
        let divs = document.getElementsByClassName('chPM');
        for (let inp of divs) {
            if (inp.checked)
                ids.push(inp.value)
        }
        if (ids.length == 0) {
            let notify = document.getElementsByClassName('noti')[0];
            notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                    Please Select Projects
                </div>`;
            setTimeout(() => {
                notify.removeChild(notify.lastChild)
            }, 3000);
            return;
        }
        form_data.append('project_id', ids.join(','));
        let notify = document.getElementsByClassName('noti')[0];
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL1}/project/user_module/${details.id}/`,
            data: form_data,
            headers: {
                "Content-Type": "multipart/form-data",
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            },
        }).then(response => {
            notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                            ${response.data.subject}
                        </div>`;
            setTimeout(() => {
                notify.removeChild(notify.lastChild)
            }, 3000);
            getUser()
        }).catch(err => {
            notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                            ${err.response.data.message}
                        </div>`;
            setTimeout(() => {
                notify.removeChild(notify.lastChild)
            }, 3000);
            console.log(err)
        })
    }
    let navigate = useNavigate();
    const fileTypes1 = ["PDF"];
    const [file1, setFile1] = useState(null);
    const handleChange1 = (file) => {
        setFile1(file);
    };
    const [Ures, setUr] = useState(false)
    const upload = async (e) => {
        let notify = document.getElementsByClassName('noti')[0];
        if (file1) {
            e.target.style.cursor = 'wait'
            var formData = new FormData();
            formData.append('resume', file1)
            await axios({
                method: "patch",
                url: `${process.env.REACT_APP_API_URL1}/hr/user_module/${details.id}/`,
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                },
            }).then(async response => {
                console.log(response)
                notify.innerHTML += `<div style='background-color:#23C552' class='notifyUser'>
                            ${response.data.message}
                        </div>`;
                e.target.style.cursor = 'unset'
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
                getUser()
            }).catch(err => {
                console.log(err)
                console.log(formData)
            })
        } else {
            notify.innerHTML += `<div style='background-color:#23C552' class='notifyUser'>
                        Please upload PDF a file
                    </div>`;
            setTimeout(() => {
                notify.removeChild(notify.lastChild)
            }, 3000);
        }
    }
    return (
        <div className='p-details indinv' ><br />
            <center><h1>User Details</h1></center><br /><br />
            <table className='p-details-table'>
                <tr>
                    <td><b>Name : </b>{details.first_name}&ensp;{details.last_name}</td>
                    <td><b>Email : </b>{details.email}</td>
                </tr>
                <tr>
                    <td><b>Profile Pic : </b><span style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} onClick={() => window.open(process.env.REACT_APP_API_URL1 + details.Get_detailes.profile_pic, "File View", `popup,height=700,width=1000`)} >View</span></td>
                    <td style={{ maxHeight: 'fit-content' }}><b>Resume : </b><span style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} onClick={() => window.open(process.env.REACT_APP_API_URL1 + details.Get_detailes.resume, "File View", `popup,height=700,width=1000`)} >View</span>
                        { Ures ? <><span onClick={() => setUr(false)} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} >Cancel</span>&emsp;</> : <></>}
                        {type=='HR'?<span onClick={(e) => {
                            !Ures ? setUr(true) : upload(e)
                        }} style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} >{Ures ? 'Submit' : 'Edit'}</span>:<></>}
                        {type=='HR' && Ures ? <FileUploader children={
                            <div className='drop-zone'>
                                <p>Click or drag and drop your files{!file1 ? <><br />{fileTypes1.join(', ')}</> : <></>}<br />{file1 ? `${file1.name}` : ""}</p>
                            </div>
                        } handleChange={handleChange1} name="file1" types={fileTypes1} /> : <></>}
                    </td>
                </tr>
                <tr>
                    <td><b>Type of Account : </b>{details.type_of_account}</td>
                    <td><b>Gender : </b>{details.Get_detailes.gender || <cite><small>Resume Not Provided</small></cite>}</td>
                </tr>
                <tr>
                    <td><b>Country : </b>{details.Get_detailes.country || <cite><small>Resume Not Provided</small></cite>}</td>
                    <td><b>State : </b>{details.Get_detailes.state_region || <cite><small>Resume Not Provided</small></cite>}</td>
                </tr>
                <tr>
                    <td><b>Address : </b>{details.Get_detailes.address || <cite><small>Resume Not Provided</small></cite>}</td>
                    <td><b>Experience : </b>{details.Get_detailes.experiance || <cite><small>Resume Not Provided</small></cite>}</td>
                </tr>
                <tr>
                    <td><b>Date of Birth : </b>{details.Get_detailes.date_of_birth || <cite><small>Resume Not Provided</small></cite>}</td>
                    <td><b>Specification : </b>{details.Get_detailes.specififcation || <cite><small>Resume Not Provided</small></cite>}</td>
                </tr><br />
                {type == 'PROJECT MANAGER' ? <div>
                    <b>Selected for Projects : </b><br /><br />
                    {details.project_selecteds.map(m => {
                        return <><input className='chPM' type='checkbox' id={m.id} value={m.id} />&emsp;<label for={m.id}>{m.project_name + ' ' + m.project_id}</label><br /></>
                    })}
                    <div className='indinvB'>
                        <button type='button' onClick={() => putP()} className='indinvsec'>Submit</button>
                    </div>
                </div> : <></>}
            </table>
            <div className='indinvB'>
                <button type='button' onClick={() => navigate(-1)} className='indinvsec'>Back</button>
                <button type='submit' onClick={() => { window.print() }}>Print</button>
            </div>
        </div>
    )
}

{/*
    details :
        all=>if not filled show fill
        resume date not selecting. ,  country dropdown
        passport : jpeg,pdf,jpg,png
        bank: country drop down
    all:
        contract filter : set alignments
        filter submit button
        single view desc ...
    hr :    
        user on add to project
        on add popup close and cancel select
        project details
    consultant : 
        invoice create alignments,currency add 
        invoice single hours/days
        invoice post sub desc bug 
        contract single view assigned date,assigned proj name, alignments till/desc to last
    project manager :
        create project alignments,text size
        create project specification dropdown
        on crete flush data from feilds
        
*/ }
 